import { Radio, Select } from 'antd'
import axios from 'axios'
import { MDBInput, MDBTextArea } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
// import { Form } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import apiUrls from '../../Api/MainApi'
import { ToastContainer, toast } from 'react-toastify'

function NewCarPolicyDetailRegistration({ formData, setFormData, setPersonalInfoError }) {
    const navigate = useNavigate();
    const [assets, setAssets] = useState({
        loan: null,
    })
    const [errors, setErrors] = useState({ // to store errors
        FirstName: '',
        LastName: '',
        EmailcommunicationId: '',
        MobilecommunicationId: '',
        Address: '',
        state: '',
        city: '',
        pincode: '',
        engineNumber: '',
        chassisNumber: '',
        cityName: '',
        bankName: ''
    })
    const [stateDropdown, setStateDropdown] = useState([]); // to store the data from api
    const [cityDropdown, setCityDropdown] = useState([]); // to store the data from api
    const [pincodeDropdown, setPincodeDropdown] = useState([]); // to store the data from api
    const [bankDropdown, setBankDropdown] = useState([]); // to store the data from api
    useEffect(() => {
        const fetchData = async () => { // to get the bank
            if (assets.loan === "yes") {
                const bankResponse = await axios.post(apiUrls.GetBankNameDropDownMotor, { SearchText: '' });
                const bankData = bankResponse.data.data
                setBankDropdown(bankData);
            }
        }
        fetchData()
    }, [assets.loan])

    // this useEffect is used to combined all the three apis that we are calling for state city and pincode applying required conditions
    useEffect(() => {
        const data = JSON.parse(sessionStorage.getItem('CarQuotationRequest'))
        const fetchStateData = async () => {
            const stateResponse = await axios.post(apiUrls.GetInsurerStateDropDown, { InsurerID: data.InsurerID });
            console.log(stateResponse, "Line 49")
            const stateData = stateResponse.data.data;
            setStateDropdown(stateData);
        };
        const fetchCityData = async (stateId) => {
            const cityResponse = await axios.post(apiUrls.GetInsurerCityDropDown, { InsurerID: data.InsurerID, StateID: stateId });
            const cityData = cityResponse.data.data;
            setCityDropdown(cityData);
        };
        const fetchPincodeData = async (stateId, cityId) => {
            const pincodeResponse = await axios.post(apiUrls.GetInsurerPincodeDropDown, { InsurerID: data.InsurerID, StateID: stateId, CityID: cityId });
            const pincodeData = pincodeResponse.data.data;
            setPincodeDropdown(pincodeData);
        };
        const fetchData = async () => {
            await fetchStateData();
            if (formData.State) {
                await fetchCityData(formData.State);
            }
            if (formData.State && formData.City) {
                await fetchPincodeData(formData.State, formData.City);
            }
        };
        fetchData(); //  finally calling this function for api 
    }, [formData.State, formData.City]);

    // const handleBankChange = (value) => {  // to manage state 
    // }
    const handleStateChange = (value, option) => {  // to manage state 
        setFormData(prev => ({
            ...prev,
            State: value,
            stateName: option.label
        }))
    }
    const handleCityChange = (value, option) => { // to manage city 
        setFormData(prev => ({
            ...prev,
            City: value,
            cityName: option.label
        }))
    }
    const handlePincodeChange = (value, option) => { // to manage pincode
        setFormData(prev => ({
            ...prev,
            pincode: value,
            pincodeName: option.label
        }))
    }
    const handleChange = (e) => {         //  to handle other fields
        const { name, value } = e.target;
        setFormData(prev => ({   //  setting the data to the main formData
            ...prev,
            [name]: value,
        }))
        let error = '';
        let hasError = false;

        if (name === 'FirstName') {
            if (value.trim() === "") {
                error = "First Name is required";
                hasError = true;
            }
        } else if (name === 'LastName') {
            if (value.trim() === "") {
                error = 'Last name required';
                hasError = true;
            }
        } else if (name === 'Address') {
            if (value.trim() === "") {
                error = 'Address name required';
                hasError = true;
            }
        } else if (name === 'cityName') {
            if (value.trim() === "") {
                error = 'City name required';
                hasError = true;
            }
        } else if (name === 'EmailcommunicationId') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                error = 'Invalid email format';
                hasError = true;
            }
        } else if (name === 'MobilecommunicationId') {
            const mobileRegex = /^\d{10}$/;
            if (!mobileRegex.test(value)) {
                error = 'Mobile number must be 10 digits';
                hasError = true;
            }
        } else if (name === 'engineNumber') {
            // const engineNumberRegex = /^[A-HJ-NPR-Z0-9]{11,17}$/; 
            //  if (!engineNumberRegex.test(value)) {
            if (value.trim() === "") {
                error = 'Enter valid engine number';
                hasError = true;
            }
        } else if (name === 'chassisNumber') {
            const chassisNumberRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
            if (!chassisNumberRegex.test(value)) {
                error = 'Enter valid chassis number';
                hasError = true;
            }
        } else {
            hasError = false
        }

        if (!hasError) {
            // Clear the error if the input is valid
            setPersonalInfoError(false);
        } else {
            setPersonalInfoError(true);
        }

        setErrors(prev => ({
            ...prev,
            [name]: error,
        }));

    }
    // const handleRadioChange = (e) => {
    //     const { value } = e.target;
    //     setAssets(prev => ({
    //         ...prev,
    //         loan: value,
    //     }));
    // };


    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    return (
        <>
            {/* <Form autoComplete='off' autoSave='off'> */}
            <div className='container'>

                <div className='row mt-3'>
                    <div className='col-md-6 col-sm-12 policy-detail-input' autoSave='off'>
                        <label className='mb-2'>Enter First Name <span className='text-danger'>*</span></label>
                        <MDBInput
                            autoComplete='off'
                            name='FirstName'
                            value={formData.FirstName}
                            onChange={handleChange}
                            label='First Name'
                            id='name'
                            type='text'
                        />
                        {errors.FirstName && <div className="text-danger">{errors.FirstName}</div>}
                    </div>
                    <div className='col-md-6 col-sm-12 policy-detail-input' autoSave='off'>
                        <label className='mb-2'>Enter Last Name <span className='text-danger'>*</span></label>
                        <MDBInput
                            autoComplete='off'
                            name='LastName'
                            value={formData.LastName}
                            onChange={handleChange}
                            label='Last Name'
                            id='name'
                            type='text'
                        />
                        {errors.LastName && <div className="text-danger">{errors.LastName}</div>}
                    </div>
                    <div className='col-md-6 col-sm-12 policy-detail-input'>
                        <label className='mb-2' >Enter Number <span className='text-danger'>*</span></label>
                        <MDBInput
                            name='MobilecommunicationId'
                            value={formData.MobilecommunicationId}
                            onChange={handleChange}
                            label='Number'
                            id='number'
                            type='text'
                        />
                        {errors.MobilecommunicationId && <div className="text-danger">{errors.MobilecommunicationId}</div>}
                    </div>
                    <div className='col-md-6 col-sm-12 policy-detail-input'>
                        <label className='mb-2' >Enter Email <span className='text-danger'>*</span></label>
                        <MDBInput
                            name='EmailcommunicationId'
                            value={formData.EmailcommunicationId}
                            onChange={handleChange}
                            label='Email'
                            id='email'
                            type='text'
                        />
                        {errors.EmailcommunicationId && <div className="text-danger">{errors.EmailcommunicationId}</div>}
                    </div>
                    <div className='col-md-4 col-sm-12 policy-detail-input mt-2'>
                        <label>Enter State <span className='text-danger'>*</span></label>
                        <Select
                            name="State"
                            showSearch
                            filterOption={filterOption}
                            value={formData.State}
                            onChange={handleStateChange}
                            options={(stateDropdown || [
                                {
                                    id: 0,
                                    name: "No State Found",
                                }
                            ]).map((state) => ({ key: `state-${state.id}`, value: state.id, label: state.name }))}
                            className='mt-2'
                            placeholder="Select State"
                        />
                        {errors.state && <div className="text-danger">{errors.state}</div>}
                    </div>
                    <div className='col-md-4 col-sm-12 policy-detail-input mt-2'>
                        <label>Enter City <span className='text-danger'>*</span></label>
                        <Select
                            name="City"
                            showSearch
                            filterOption={filterOption}
                            value={formData.City}
                            onChange={handleCityChange}
                            options={(cityDropdown || [
                                {
                                    id: 0,
                                    name: "No State Found",
                                }
                            ]).map((city) => ({ key: `city-${city.id}`, value: city.id, label: city.name }))}
                            className='mt-2'
                            placeholder="Select City"
                            disabled={!formData.State}
                        />
                        {errors.city && <div className="text-danger">{errors.city}</div>}
                    </div>
                    <div className='col-md-4 col-sm-12 policy-detail-input mt-2'>
                        <label>Enter Pincode <span className='text-danger'>*</span></label>
                        <Select
                            name="pincode"
                            showSearch
                            filterOption={filterOption}
                            value={formData.pincode}
                            onChange={handlePincodeChange}
                            options={(pincodeDropdown || [
                                {
                                    id: 0,
                                    name: "No pincode Found",
                                }
                            ]).map((pincode) => ({ key: `pincode-${pincode.id}`, value: pincode.id, label: pincode.name }))}
                            className='mt-2'
                            placeholder="Select Pincode"
                            disabled={!formData.City}
                        />
                        {errors.pincode && <div className="text-danger">{errors.pincode}</div>}
                    </div>
                    <div className='col-md-6 col-sm-12 policy-detail-input mt-2' autoSave='off'>
                        <label className='mb-2'>Flat No. <span className='text-danger'>*</span></label>
                        <MDBInput
                            autoComplete='off'
                            name='flatNo'
                            value={formData.flatNo}
                            onChange={handleChange}
                            label='Flat No'
                            id='name'
                            type='text'
                        />
                        {errors.flatNo && <div className="text-danger">{errors.flatNo}</div>}
                    </div>
                    <div className='col-md-6 col-sm-12 policy-detail-input mt-2' autoSave='off'>
                        <label className='mb-2'>Street No. <span className='text-danger'>*</span></label>
                        <MDBInput
                            autoComplete='off'
                            name='StreetNo'
                            value={formData.StreetNo}
                            onChange={handleChange}
                            label='Street No'
                            id='name'
                            type='text'
                        />
                        {errors.StreetNo && <div className="text-danger">{errors.StreetNo}</div>}
                    </div>
                    <div className='col-md-12 col-sm-12 policy-detail-input'>
                        <label className='mb-2'>Enter Address <span className='text-danger'>*</span></label>
                        <MDBTextArea
                            name="Address"
                            value={formData.Address}
                            onChange={handleChange}
                            label="Message"
                            id="textAreaExample"
                            rows={2}
                        />
                        {errors.Address && <div className="text-danger">{errors.Address}</div>}
                    </div>
                </div>
                <h5 className='mt-4 policy-detail-title'>Vechile Details </h5>
                <div className='row mt-3 mb-3'>
                    <div className='col-md-6 col-sm-12 policy-detail-input'>
                        <label className='mb-2'>Enter Engine number <span className='text-danger'>*</span></label>
                        <MDBInput
                            name='engineNumber'
                            value={formData.engineNumber}
                            onChange={handleChange}
                            label='Engine No'
                            id='engine'
                            type='text'
                        />
                        {errors.engineNumber && <div className="text-danger">{errors.engineNumber}</div>}
                    </div>
                    <div className='col-md-6 col-sm-12 policy-detail-input'>
                        <label className='mb-2'>Enter Chassis number <span className='text-danger'>*</span></label>
                        <MDBInput
                            name='chassisNumber'
                            value={formData.chassisNumber}
                            onChange={handleChange}
                            label='Chassis No'
                            id='chassis'
                            type='text'
                        />
                        {errors.chassisNumber && <div className="text-danger">{errors.chassisNumber}</div>}
                    </div>
                </div>
                {/* <div className='row mt-4'>
                <div className='col-md-5 col-sm-12 policy-detail-input d-flex flex-column'>
                    <label>Is your vehicle financed/ on loan?</label>
                    <Radio.Group className='mt-2'>
                        <Radio
                            name='loan'
                            value='yes'
                            onChange={handleRadioChange}
                        > Yes
                        </Radio>
                        <Radio
                            name='loan'
                            value='no'
                            onChange={handleRadioChange}
                        >No
                        </Radio>
                    </Radio.Group>
                </div>
            </div> */}
                {/* {
                assets.loan === 'yes' && (
                    <div className='row mt-4'>
                        <div className='col-md-6 col-sm-12 policy-detail-input'>
                            <label className='mb-2'>Company which has provided the loan</label>
                            <Select
                                name="bank"
                                showSearch
                                filterOption={filterOption}
                                value={assets.bankName}
                                onChange={handleBankChange}
                                options={(bankDropdown || [
                                    {
                                        id: 0,
                                        name: "No Bank Found",
                                    }
                                ]).map((bank) => ({ key: `bank-${bank.id}`, value: bank.id, label: bank.name }))}
                                placeholder="Select Bank"
                            />
                            {errors.bankName && <div className="text-danger">{errors.bankName}</div>}
                        </div>
                        <div className='col-md-6 col-sm-12 policy-detail-input'>
                            <label className='mb-2'>City where the loan was taken</label>
                            <MDBInput
                                name='cityName'
                                value={assets.cityName}
                                onChange={handleChange}
                                label='City'
                                id='city'
                                type='text'
                            />
                            {errors.cityName && <div className="text-danger">{errors.cityName}</div>}
                        </div>
                    </div>
                )
            } */}
                {/* <div className='d-flex mt-4 justify-content-center mb-4'>
                        <div>
                            <button className='btn btn-success'>Submit</button>
                        </div>
                    </div> */}
            </div>
            {/* </Form> */}
            <ToastContainer />
        </>
    )
}

export default NewCarPolicyDetailRegistration
